import React, { useMemo } from 'react'
import { Col, Collapse, Row } from 'antd'
import moment from 'moment'

import { RequestQuoteAir } from 'src/types'

import { Text } from 'src/components/Ant'
import Images from 'src/config/images'
import InfoItem from 'src/views/Requests/views/Form/components/Steps/Services/components/Air/components/SearchResultItem/info-item'
import TagFamily from 'src/views/Requests/views/Form/components/Steps/Services/components/Air/components/SearchResultItem/tag-family'

type Props = {
  item: RequestQuoteAir
}

function QuoteAirItem({ item }: Props): JSX.Element {
  const arrival_date = useMemo(
    () => moment.unix(item.arrival_date).utc(),
    [item.arrival_date]
  )
  const departure_date = useMemo(
    () => moment.unix(item.departure_date).utc(),
    [item.departure_date]
  )

  const request_quote_air_fares = item.request_quote_air_fares.find(
    ({ selected }) => selected
  )

  return (
    <Row
      style={{
        border: '1px dashed #e8e8e8',
        borderRadius: 4,
        marginBottom: 24
      }}
    >
      <Collapse
        bordered={false}
        destroyInactivePanel
        style={{ background: 'transparent' }}
      >
        <Collapse.Panel
          style={{ border: 0 }}
          key={item.request_quote_air_id}
          header={
            <Row
              align="middle"
              gutter={8}
              justify="center"
              style={{
                borderRadius: 4,
                padding: '12px 16px'
              }}
              type="flex"
            >
              <Col span={3}>
                <Row align="middle" justify="center" type="flex">
                  <img
                    alt="gol"
                    src={Images.airlines[item.company] || Images.noImage}
                    style={{ maxHeight: 45, maxWidth: 45 }}
                  />
                </Row>
              </Col>
              <Col span={7}>
                <Row
                  align="middle"
                  justify="center"
                  type="flex"
                  style={{ flexDirection: 'column' }}
                >
                  <Text style={{ fontSize: '12px' }} type="secondary">
                    {departure_date.format('DD/MM/YYYY')}
                  </Text>
                  <Text strong style={{ fontSize: '18px' }}>
                    {departure_date.format('HH:mm')}
                  </Text>
                  <Text style={{ fontSize: '12px' }} type="secondary">
                    {item.air_origin}
                  </Text>
                </Row>
              </Col>
              <Col span={5}>
                <Row
                  align="middle"
                  justify="center"
                  type="flex"
                  style={{ flexDirection: 'column' }}
                >
                  <Text
                    strong
                    style={{
                      borderBottom: '2px solid #52c41a',
                      fontSize: '18px',
                      padding: '0 4px 4px 4px'
                    }}
                  >
                    {`${item.stops ? item.stops : 'no'} stop${
                      item.stops > 1 ? 's' : ''
                    }`}
                  </Text>
                  <Text style={{ fontSize: '12px' }} type="secondary">
                    {`Vôo ${item.request_quote_air_flights[0].flight_code}`}
                  </Text>
                </Row>
              </Col>
              <Col span={7}>
                <Row
                  align="middle"
                  justify="center"
                  type="flex"
                  style={{ flexDirection: 'column' }}
                >
                  <Text style={{ fontSize: '12px' }} type="secondary">
                    {arrival_date.format('DD/MM/YYYY')}
                  </Text>
                  <Text strong style={{ fontSize: '18px' }}>
                    {arrival_date.format('HH:mm')}
                  </Text>
                  <Text style={{ fontSize: '12px' }} type="secondary">
                    {item.air_destiny}
                  </Text>
                </Row>
              </Col>
              <Col span={2}>
                {TagFamily({
                  baggage_amount: request_quote_air_fares?.baggage_amount,
                  baggage_weight: request_quote_air_fares?.baggage_weight,
                  baggage: request_quote_air_fares?.baggage,
                  family: request_quote_air_fares?.family
                })}
              </Col>
            </Row>
          }
        >
          {item.request_quote_air_flights.map(flightItem => (
            <InfoItem key={flightItem.flight_code} item={flightItem} />
          ))}
        </Collapse.Panel>
      </Collapse>
    </Row>
  )
}

export default QuoteAirItem
